export default __webpack_public_path__ + "1ea35a3329f80a3bff787f20aaa17a09.svg";